import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/img/landingPage/');

export default function G(): JSX.Element {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('landingPage');

    const powerInfoList = [
        {
            name: t('secG_Light'),
            type1: t('secG_Light_1'),
            type2: t('secG_Light_2'),
            type3: t('secG_Light_3'),
        },
        {
            name: t('secG_WiFiRouter'),
            type1: t('secG_WiFiRouter_1'),
            type2: t('secG_WiFiRouter_2'),
            type3: t('secG_WiFiRouter_3'),
        },
        {
            name: t('secG_TV'),
            type1: t('secG_TV_1'),
            type2: t('secG_TV_2'),
            type3: t('secG_TV_3'),
        },
        {
            name: t('secG_Refrigerator'),
            type1: t('secG_Refrigerator_1'),
            type2: t('secG_Refrigerator_2'),
            type3: t('secG_Refrigerator_3'),
        },
        {
            name: t('secG_Electrickettle'),
            type1: t('secG_Electrickettle_1'),
            type2: t('secG_Electrickettle_2'),
            type3: t('secG_Electrickettle_3'),
        },
    ];

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    return (
        <div className={`landing_page_G1 ${css.landing_page_G1}`}>
            <div className="pageG_powerBox">
                <div className="pageG_powerTitle">{t('secF_powerList')}</div>
                <div className="pageG_powerList">
                    <div className="list-outer" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                        <div className="list-inner">
                            <div className="pageG_powerRow pageG_powerRow_th">
                                <div className="powerRowItem"></div>
                                <div className="powerRowItem">
                                    <div>
                                        <EFPic
                                            name={locale === 'au' ? [`product/1.webp`, `product/1.png`] : [`pc/g-5.webp`, `pc/g-5.png`]}
                                            className="powerItemImg"
                                        />
                                        <div className="powerItemTitle">{t('secG_item1_title1')}</div>
                                    </div>
                                </div>
                                <div className="powerRowItem">
                                    <div>
                                        <EFPic
                                            name={locale === 'au' ? [`product/2.webp`, `product/2.png`] : [`pc/g-3.webp`, `pc/g-3.png`]}
                                            className="powerItemImg"
                                        />
                                        <div className="powerItemTitle">{t('secG_item2_title1')}</div>
                                    </div>
                                </div>
                                <div className="powerRowItem">
                                    <div>
                                        <EFPic
                                            name={locale === 'au' ? [`product/3.webp`, `product/3.png`] : [`pc/g-4.webp`, `pc/g-4.png`]}
                                            className="powerItemImg"
                                        />
                                        <div className="powerItemTitle">{t('secG_item3_title1')}</div>
                                    </div>
                                </div>
                            </div>
                            {(locale === 'au' ? powerInfoList?.slice(0, 5) : powerInfoList).map((item: any, index: number) => (
                                <div className="pageG_powerRow_tr" key={index}>
                                    <div className="powerRowItem">
                                        <span className="powerRowItemName">{item.name}</span>
                                    </div>
                                    <div className="powerRowItem">{item.type1}</div>
                                    <div className="powerRowItem">{item.type2}</div>
                                    <div className="powerRowItem">{item.type3}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {locale === 'au' && <p className="memo">{t('secG_memo')}</p>}
            </div>
        </div>
    );
}
